/**
 * Following Section 4 of the Master Template:
 * Frontend -> Proxy (server.js/vite) -> Firebase Cloud Function (askAI)
 */
export const getOpenAIAppIdeaConsultation = async (userInput: string) => {
  // Constructed prompt to enforce the persona and constraints
  const systemContext = `
    You are a strategist for Tiny Systems. We build simple custom web apps for home businesses to save them time.
    
    User's Daily Chore: "${userInput}"
    
    Your Task:
    1. Suggest a specific "tiny web tool" (e.g., inventory dashboard, automated invoice generator, AI FAQ bot) we could build to solve this.
    2. Focus strictly on how it saves time.
    3. IMPORTANT: Keep your response under 50 words. Be concise.
    4. If you sense the user is keen to explore more, suggest they chat with us directly. Otherwise, just leave the idea as food for thought.
  `;

  try {
    // Use relative path to leverage the server proxy (fixes CORS)
    const response = await fetch("/api/askAI", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // Matches Section 4.1 contract
      body: JSON.stringify({ prompt: systemContext }),
    });

    if (!response.ok) {
      throw new Error("LLM request failed");
    }

    const data = await response.json();

    // The function returns { output: "..." } per Section 4.1
    return data.output || "I received an empty response from the strategist.";
  } catch (err) {
    console.error("AI Service Error:", err);
    return "🌐 **Connection Issue**: I couldn't reach the secure AI gateway. Please check your internet or try again in a moment!";
  }
};